import stylesW from '../LayoutW.module.scss'
import ListItemButton from '@mui/material/ListItemButton'
import { useLocation, useNavigate } from 'react-router-dom'

import faq from 'assets/side_pane_new_icons/faqin.svg'
import home from 'assets/side_pane_new_icons/home.svg'
import task from 'assets/side_pane_new_icons/note.svg'
import notes from 'assets/side_pane_new_icons/sticky.png'
import close from 'assets/side_pane_new_icons/close.png'
import docs from 'assets/side_pane_new_icons/document.svg'
import user_image from 'assets/side_pane_new_icons/account.png'
import reload from 'assets/side_pane_new_icons/reload.png'

import project from 'assets/side_pane_new_icons/project.svg'
import stream from 'assets/side_panel_icons/5stream.png'
import table from "assets/side_panel_icons/tabel.png";

const Popup = ({ x, y, closePopup }) => {
  const navigate = useNavigate()
  const location = useLocation()

  let data;

  const ReRenderWindow = async () => {
    try {

    
      window.location.reload()
    } catch (error) {
      console.log("CHU")
    }
  }

  return (
    <div className={stylesW.popup_box_shadow} style={{ top: y, left: x, }}>
      <ListItemButton
        disablePadding
        onClick={() => closePopup()}

      >
        <img className={stylesW.image_icon} src={close} alt="" />
        <p >Закрыть</p>
      </ListItemButton>
      <ListItemButton
        disablePadding
        onClick={() => ReRenderWindow()}
      >
        <img className={stylesW.image_icon} src={reload} alt="" />
        <p >Обновить</p>
      </ListItemButton>
      <hr></hr>
      <ListItemButton
        disablePadding
        onClick={() => navigate(`/home/`)}
        style={
          location.pathname.includes('home')
            ? { background: '#E8E8EF', }
            : {}
        }
      >
        <img style={
          location.pathname.includes('home')
            ? { filter: 'invert(0.8)' }
            : {}
        } className={stylesW.image_icon} src={home} alt="" />
        <p style={
          location.pathname.includes('home')
            ? { color: 'black' }
            : {}
        }>Главная</p>
      </ListItemButton>
    
    
   
        <ListItemButton
          disablePadding
          onClick={() => navigate(`/tests/`)}
          style={
            location.pathname.includes('test') ||
              location.pathname.includes('/tests')
              ? { background: '#E8E8EF' }
              : {}
          }
        >
          <img style={
            location.pathname.includes('test') ||
              location.pathname.includes('/tests')
              ? { filter: 'invert(0.8)' }
              : {}
          } className={stylesW.image_icon} src={stream} alt="" />

          <p style={
            location.pathname.includes('flow')
              ||
              location.pathname.includes('/tests')
              ? { color: 'black' }
              : {}
          }>Тесты</p>
        </ListItemButton>
    
        <ListItemButton
          disablePadding
          onClick={() => navigate(`/tasks/`)}
          style={
            location.pathname.includes('task')
              ? { background: '#E8E8EF', }
              : {}
          }
        >
          <img style={
            location.pathname.includes('task')
              ? { filter: 'invert(0.8)' }
              : {}
          } className={stylesW.image_icon} src={task} alt="" />

          <p style={
            location.pathname.includes('task')
              ? { color: 'black' }
              : {}
          }>Задачи</p>
        </ListItemButton>
   
        <ListItemButton
          disablePadding
          onClick={() => navigate(`/notes/`)}
          style={
            location.pathname.includes('notes')
              ? { background: '#E8E8EF', }
              : {}
          }
        >

          <img style={
            location.pathname.includes('notes')
              ? { filter: 'invert(0.8)' }
              : {}
          } className={stylesW.image_icon} src={notes} alt="" />

          <p style={
            location.pathname.includes('notes')
              ? { color: 'black' }
              : {}
          }>Заметки</p>
        </ListItemButton>
  
        <ListItemButton
          disablePadding
          onClick={() => navigate(`/report-card/`)}
          style={
            location.pathname.includes("report")
              ? { background: '#E8E8EF' }
              : {}
          }


        >
          <img style={
            location.pathname.includes('report')
              ? { filter: 'invert(0.8)' }
              : {}
          } className={stylesW.image_icon} src={table} alt="" />

          <p style={
            location.pathname.includes('report')
              ? { color: 'black' }
              : {}
          }>Таймшит</p>
        </ListItemButton>
 
        <ListItemButton
          disablePadding
          onClick={() => navigate(`/statements/`)}
          style={
            location.pathname.includes('statement')
              ? { background: '#E8E8EF', borderBottomLeftRadius: "12px", borderTopLeftRadius: "12px" }
              : {}
          }
        >
          <img style={
            location.pathname.includes('statement')
              ? { filter: 'invert(0.8)' }
              : {}
          } className={stylesW.image_icon} src={docs} alt="" />

          <p style={
            location.pathname.includes('statement')
              ? { color: 'black' }
              : {}
          } >Документооборот</p>
        </ListItemButton>

      <hr></hr>
      <ListItemButton
        disablePadding
        onClick={() => navigate(`/personalcard`)}
        style={
          location.pathname.includes('personalcard')
            ? { background: '#E8E8EF' }
            : {}
        }

      >
        <img style={
          location.pathname.includes('home')
            ? { filter: 'invert(0.8)' }
            : {}
        } className={stylesW.image_icon} src={user_image} alt="" />
        <p >Профиль</p>
      </ListItemButton>
    



    </div>
  );
};
export default Popup